<template>
    <v-container fluid >
        <v-card flat>
          <v-card-title>
            <v-toolbar>
                <v-icon color="blue">receipt</v-icon>
                <v-toolbar-title class="font-weight-light"> 
                    <v-row>
                        <v-col>
                            <div>&nbsp; Auditoría de Legajo Digital</div>
                        </v-col>
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="hideActiveSubTask"><v-icon>close</v-icon></v-btn>
            </v-toolbar>            
          </v-card-title>
          
          <v-card-text>
            <v-row no-gutters>
                <span class="subtitle-1">Log de Estados</span>
            </v-row>
            <v-row no-gutters>
                <v-data-table 
                    :headers="headers"
                    :items="solicitud.logEstadoLegajoDigital"
                    :loading="loading" hide-default-footer
                    dense
                    >
                    <template v-slot:no-data>
                        <v-alert dense :value="true" color="grey lighten-3" icon="warning">
                            No se encontraron datos
                        </v-alert>
                    </template>

                    <template v-slot:item="{ item }">
                        <tr>
                        <td  class="text-xs-left caption">{{ item.fecha  | dateParse() | dateFormat('DD-MM-YYYY HH:mm') }}</td>
                        <td class="text-xs-left caption" colspan="2">
                            <tr>
                                <td class="text-uppercase font-weight-medium caption">
                                    {{ item.estadoDescripcion }}
                                </td>
                                <td class="text-xs-left caption">{{ item.responsable }}</td>
                            </tr>  
                            <tr>
                                <td colspan="2" v-if="item.comentarios && item.comentarios != ''" class="font-weight-light caption">
                                    {{ item.comentarios }}
                                </td>  
                            </tr>  
                        </td>
                        
                        </tr>
                    </template>
                </v-data-table>
            </v-row>

            <v-row no-gutters>
                <span class="subtitle-1">&nbsp;</span>
            </v-row>

            <v-row no-gutters >
                <span class="subtitle-1 font-weight-black">Modificar Estado </span>
            </v-row>
            
            <v-row no-gutters>
                <v-col>
                    <v-autocomplete v-model="model.nuevoEstadoId" :items="estadosDisponibles" :disabled="!puedeSeleccionarEstado"
                        item-text="descripcion" item-value="id" label="Cambiar a" placeholder="Próximo Estado" 
                        :menu-props="{minWidth:'200'}"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-text-field v-model="model.comentarios" label="Comentarios"></v-text-field>
                </v-col>
            </v-row>            
            <v-row no-gutters align="center" justify="center">
                <v-col cols="6">
                    <v-tooltip v-if="showEnviarSmsValidacion" bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="green" @click.stop="enviarSmsValidacion">
                                Enviar SMS Validación
                                <v-icon right dark small>email</v-icon>
                            </v-btn>
                        </template>
                        <span> Al hacer Click, se enviará un SMS al celular del cliente para que valide el número.</span>
                    </v-tooltip>
                </v-col>
            </v-row>            
            
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="blue darken-1" text @click.stop="hideActiveSubTask">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green" dark  @click.stop="save" :disabled="this.model.nuevoEstadoId==null">Guardar Cambios</v-btn>
          </v-card-actions>  
        </v-card>
    </v-container>
</template>

<script>


import { http } from '@/axios'
import {
  mapGetters,
  mapMutations,
} from 'vuex'

export default {
  data: () => ({
    editModeOn: false,    
    loading: false,
    headers: [ // definición de columnas
        { text: 'Fecha', value: 'fecha' , width: 140},
        { text: 'Estado', value: 'estadoDescripcion' },
        { text: 'Responsable', value: 'responsable', width: 90},            
    ],
    listEstados:[],
    solicitud: {},
    model: {proximoEstadoId:'1',comentarios:null},
    estadoActualId: 0
  }),
  props: {
    personaId: {
      type: String,
      required: false,
      default: null
    },
    creditoId: {
      type: String,
      required: false
    },
  },
  watch:{

  },
  computed:{
    ...mapGetters(["user"]),      
    showEnviarSmsValidacion: function(){
        //muestro el boton de enviar sms de validacion para:
        //legajo en estado Completo, Teléfonos a Verificar y origen del credito comercio o online
        return true; // this.estadoActualId == 2 && (this.solicitud.tipoCanalVentaId == 3 || this.solicitud.infoCanalVenta.toUpperCase().includes('ONLINE'));
    },
    puedeSeleccionarEstado: function(){
        return this.solicitud &&  this.solicitud.logEstadoLegajoDigital && (this.solicitud.logEstadoLegajoDigital[0].estadoId == 2);
    },
    estadosDisponibles: function(){
        var list = this.listEstados;
        if(this.solicitud && this.solicitud.logEstadoLegajoDigital){
            if(this.solicitud.logEstadoLegajoDigital[0].estadoId == 2){
                list = this.listEstados.filter(x=> x.id == 3 || x.id == 5)
            } else if(this.solicitud.logEstadoLegajoDigital[0].estadoId == 5){
                list = this.listEstados.filter(x=> x.id == 3 )
            }
        }
        return list;
    }
  },
  async created () {
    await this.loadEstados();

    if(this.creditoId){       
       this.loadDatos();
    }
  },
  methods: {
      ...mapMutations(["hideActiveSubTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
      async loadEstados(){
        this.loading = true
        try {
            var result = await http.get('tiposestadolegajodigital'); // traigo todas
            this.listEstados = result.list;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
      },
      async loadDatos(){
        this.loading = true
         try {
            var result = await http.get('Creditos/getinfosolicitudparaanalisis?id=' + this.creditoId );
                            
            this.solicitud = result

            if(this.solicitud.logEstadoLegajoDigital.length > 0){
                if(this.listEstados.length > this.solicitud.logEstadoLegajoDigital[0].estadoId && this.solicitud.logEstadoLegajoDigital[0].estadoId < 3)
                    this.model.nuevoEstadoId = this.solicitud.logEstadoLegajoDigital[0].estadoId + 1;
                else if(this.solicitud.logEstadoLegajoDigital[0].estadoId == 4)//si esta en estado validacion sms negativa permito que se pase manualmente a estado validado
                    this.model.nuevoEstadoId = 3;
                else if(this.solicitud.logEstadoLegajoDigital[0].estadoId == 5)//si esta en ten sin contacto
                    this.model.nuevoEstadoId = 3;
                else
                    this.model.nuevoEstadoId = null;
            }
            else{
                this.model.nuevoEstadoId = 1;
            }

            this.estadoActualId = this.model.nuevoEstadoId ? (this.model.nuevoEstadoId - 1) : null;
        
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
      },
      async save(){
        this.loading = true
        
        try {
            this.model.creditoId = this.solicitud.id;

            await http.post('creditos/updatelegajodigital', JSON.stringify( this.model ) );
            this.alertSuccess('Los cambios han sido registrados')
            
            // recargo
            this.loadDatos();

        } catch (error) {
            // Error
            this.alertError(error);
        }
        this.loading = false
      },
      async enviarSmsValidacion(){
            this.loading = true;
        
            try {
                this.model.creditoId = this.solicitud.id;
                console.log(this.creditoId);

                var result = await http.post('creditos/enviarsmsvalidacionlegajodigital', JSON.stringify( this.model ) );
                this.alertSuccess('El SMS ha sido enviado.');

            } catch (error) {
                // Error
                this.alertError(error);
            }
            this.loading = false;
      }
      
  }
}
</script>